// extracted by mini-css-extract-plugin
export default {"blackph":"photo_blackph__9cH6H","contentph":"photo_contentph__1lAsN","closebtn":"photo_closebtn__Il3Kq"};